/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_LicenseInputs */

const en_gc_resources_compare_license = /** @type {(inputs: Gc_Resources_Compare_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`License`)
};

const zh_gc_resources_compare_license = /** @type {(inputs: Gc_Resources_Compare_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`许可`)
};

/**
* | output |
* | --- |
* | "License" |
*
* @param {Gc_Resources_Compare_LicenseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_license = /** @type {((inputs?: Gc_Resources_Compare_LicenseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_LicenseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_license(inputs)
	return zh_gc_resources_compare_license(inputs)
});
export { gc_resources_compare_license as "gc.resources.compare.license" }